import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-error',
  imports: [],
  templateUrl: './success-error.html',
  styleUrl: './success-error.scss',
})
export class SuccessError implements OnInit {
  @Input() success = false;
  
  constructor() {
  }
     
  ngOnInit() {
    console.log('success-error', this.success);
  }
}
